import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Badge from "../../../../components/Badge";

interface TableHeaderSectionProps {
  total: number;
  kpis: any;
}

const PaymentTableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, kpis }) => {
  const { t } = useTranslation();

  const { variant, title }: { variant: any, title: any } = useMemo(() => {
    switch (kpis?.payment_status) {
      case 'NO AMOUNT':
        return {
          variant: '',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.noAmount')
        };
      case 'OVERPAID':
        return {
          variant: 'danger',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.overpaid')
        };
      case 'PARTIAL PAID':
        return {
          variant: 'warning',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.partialPaid')
        };
      case 'PAID':
        return {
          variant: 'success',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.paid')
        };
      case 'OVERDUE':
        return {
          variant: 'danger',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.overdue')
        };
      default:
        return {
          variant: 'primary',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.noAmount')
        };
    }
  }, [kpis?.payment_status]);

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-bank-card-line ri-26px"></i>
            <h5 className="mx-3 my-0">{t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.table.title')} ({total})</h5>
          </div>
          <div className="d-flex align-items-center">
            <Badge
              text={kpis?.payment_status ?? ''}
              variant={variant}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentTableHeaderSection;
